import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Button,
  makeStyles,
} from '@material-ui/core';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

import {
  resetState,
  getRegistration,
  setErrorMessage,
} from 'modules/brandRegistration';
import {
  selectPending,
  selectLoading,
  selectBrandError,
} from 'selectors/brandRegistration';
import { selectUser } from 'selectors/user';
import LoadingMask from 'components/loadingMask';
import LoginPlaceholder from 'components/loginPlaceholder';
import Steps from './components/Steps';
import BrandSelection from './components/BrandSelection';
import BrandPosition from './components/BrandPosition';
import BrandOwners from './components/BrandOwners';
import BrandAddress from './components/BrandAddress';
import { getRegistrationSession, removeCachedRegistration } from './util';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '3rem',
    textAlign: 'cemter',
    [theme.breakpoints.down('sm')]: {
      padding: '1rem',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  progressBtns: {
    margin: '20px 0',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  error: {
    color: theme.custom.danger,
    textAlign: 'center',
  },
}));

const BrandRegistration = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const classes = useStyles();
  const pending = useSelector(selectPending);
  const loading = useSelector(selectLoading);
  const error = useSelector(selectBrandError);
  const location = useLocation();

  const abandonRegistration = () => {
    removeCachedRegistration();
    dispatch(resetState());
  };

  useEffect(() => {
    if (pending) {
      const registrationId = getRegistrationSession();

      dispatch(getRegistration(registrationId));
    }
  }, [dispatch, pending]);

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(setErrorMessage(''));
  }, [location.pathname, dispatch]);

  if (pending) {
    return <LoadingMask />;
  }

  return (
    <div className={classes.root}>
      {user ?
        (
          <>
            <Steps />
            {error && <p className={classes.error}>
              {error}
              &nbsp;
              <Button onClick={abandonRegistration} variant="contained" color="secondary">
                Restart Registration <RotateLeftIcon />
              </Button>
            </p>}
            <div className={classes.instructions}>
              <Switch>
                <Route exact path="/brands/new">
                  <BrandSelection />
                </Route>
                <Route exact path="/brands/new/positions">
                  <BrandPosition />
                </Route>
                <Route exact path="/brands/new/owners">
                  <BrandOwners />
                </Route>
                <Route exact path="/brands/new/address">
                  <BrandAddress />
                </Route>
                <Redirect to="/brands/new" />
              </Switch>
            </div>
            {loading && <LoadingMask />}
          </>
        ) : (
          <LoginPlaceholder
            title="An account is required to Register a Brand"
          />
        )
      }
    </div>
  );
};

export default BrandRegistration;

